import React from "react";
import ProxID from "../assets/images/proxid.png";
import RJE from "../assets/images/RJE.png";
import CCD from "../assets/images/concordium.png";
import MATIC from "../assets/images/polygon.png";


function AboutSide(): JSX.Element {
  return (
    <div className="2xl:border-l-2 2xl:border-primary border-dashed gap-4 grid h-max my-[25%] justify-items-center container-fluid mx-8">
      <div></div>
      <div>
        <a href="https://proxid.nl/nl/" target="_blank" rel="noreferrer">
          <img className="h-[125px]" src={ProxID} alt="ProxID" />
        </a>
      </div>
      <div>
        <a href="https://www.joh-enschede.nl/" target="_blank" rel="noreferrer">
          <img className="h-[125px]" src={RJE} alt="RJE" />
        </a>
      </div>
      <div>
        <a href="https://www.concordium.com/" target="_blank" rel="noreferrer">
          <img className="h-[125px]" src={CCD} alt="Concordium" />
        </a>
      </div>
      <div>
        <a href="https://polygon.technology/" target="_blank" rel="noreferrer">
          <img className="h-[125px]" src={MATIC} alt="Polygon" />
        </a>
      </div>
    </div>
  );
}

export default AboutSide;
